import React from 'react';
import { ResponsiveAutocomplete } from '@/components/selects/ResponsiveAutocomplete';

/** The values a yes / no filter holds. */
export const YES = 'yes';
export const NO = 'no';

const OPTIONS = [
	{ id: YES, name: 'Yes' },
	{ id: NO, name: 'No' },
];

/**
 * Pick Yes and / or No, e.g. to filter by a true / false field. value/onChange are YES / NO
 * (an array when multiple, the default). Other props go to ResponsiveAutocomplete.
 */
export const AdminYesNoPicker = ({ multiple = true, ...props }) => (
	<ResponsiveAutocomplete options={OPTIONS} multiple={multiple} {...props} />
);
